import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faPaperPlane,
  faRotateRight,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

const TriggerButton = ({ active, triggerDSS }) => {
  function handleOnClick() {
    triggerDSS();
  }
  return (
    <div
      className={"dss-trigger-btn " + (active ? "active" : "")}
      onClick={() => handleOnClick()}
    >
      <FontAwesomeIcon icon={faPaperPlane} />
    </div>
  );
};

const RefreshButton = ({ active, refreshSearch }) => {
  function handleOnClick() {
    refreshSearch();
  }
  return (
    <div
      className={"dss-refresh-btn " + (active ? "active" : "")}
      onClick={() => handleOnClick()}
    >
      <FontAwesomeIcon icon={faRotateRight} />
    </div>
  );
};

const FiltersButton = ({ active, displayFilters }) => {
  function handleOnClick() {
    displayFilters(!active);
  }
  return (
    <div
      className="dss-trigger-btn active"
      id="dss-filters-btn"
      onClick={() => handleOnClick()}
    >
      <FontAwesomeIcon icon={active ? faXmark : faFilter} />
    </div>
  );
};

export { TriggerButton, FiltersButton, RefreshButton };
